import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cx } from "@/lib/tailwind-utils";
type ShopCardDecorationTone = "gift-card" | "package" | "membership" | "service" | "product" | "medication";
interface ShopCardDecorationProps {
  frame: "tile" | "hero";
  tone: ShopCardDecorationTone;
  artwork: React.ReactNode;
  corner: React.ReactNode;
}

/** Shared card frame. Domain-specific background and corner artwork are injected. */
const ShopCardDecoration: React.FC<ShopCardDecorationProps> = t0 => {
  const $ = _c(15);
  const {
    frame,
    tone,
    artwork,
    corner
  } = t0;
  const isHero = frame === "hero";
  const isGiftCard = tone === "gift-card";
  const t1 = isHero ? "rounded-2xl" : "rounded-xl";
  const t2 = isGiftCard ? "border-primary-foreground/15" : "border-primary/15";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cx("absolute inset-3 border", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isHero ? "rounded-[14px]" : "rounded-[10px]";
  const t6 = isGiftCard ? "border-primary-foreground/10" : "border-primary/15";
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = cx("absolute inset-[14px] border border-dashed", t5, t6);
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7) {
    t8 = <div className={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== artwork || $[11] !== corner || $[12] !== t4 || $[13] !== t8) {
    t9 = <div aria-hidden={true} className="pointer-events-none absolute inset-0">{artwork}{t4}{t8}{corner}</div>;
    $[10] = artwork;
    $[11] = corner;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default ShopCardDecoration;